import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TemplateEditorComponent } from './template-editor/template-editor.component';
import { TemplateEditorModule } from './template-editor/template-editor.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, TemplateEditorModule],
  exports: [TemplateEditorComponent],
})
export class EditModule {}
